import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
import { addMessage } from './order';
const initialState = {
    brands: null,
    email: null,
    error: null,
    loading: 'idle',
    showMagicLink: false
};
export var GuestActionType;
(function (GuestActionType) {
    GuestActionType["FetchGuest"] = "guest/fetchGuest";
    GuestActionType["FetchGuestThanx"] = "guest/fetchGuestThanx";
})(GuestActionType || (GuestActionType = {}));
export const fetchGuest = createAsyncThunk(GuestActionType.FetchGuest, ({ email, callback }, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const { api } = getState().config;
    if (!api)
        return;
    try {
        const response = yield api.getGuest(email);
        if (callback)
            callback();
        return response;
    }
    catch (err) {
        const error = { error: err, email };
        return rejectWithValue(error);
    }
}));
export const fetchGuestThanx = createAsyncThunk(GuestActionType.FetchGuestThanx, ({ email, callback }, { getState, rejectWithValue, dispatch }) => __awaiter(void 0, void 0, void 0, function* () {
    const { api } = getState().config;
    if (!api)
        return;
    try {
        yield api.postThanxLogin(email, origin);
        if (callback)
            callback();
        dispatch(addMessage('Thanks! Please check your email on this device.'));
        return { email: email };
    }
    catch (err) {
        const error = { error: err, email };
        return rejectWithValue(error);
    }
}));
const guestSlice = createSlice({
    name: ReducerType.Guest,
    initialState,
    reducers: {
        resetGuest: () => initialState,
        resetGuestErrors: state => {
            state.error = null;
            state.loading = 'idle';
            state.showMagicLink = false;
        },
        setGuestEmail: (state, action) => {
            state.email = action.payload;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchGuest.fulfilled, (state, action) => {
            return Object.assign(Object.assign(Object.assign({}, state), { loading: 'idle', errors: null }), action.payload);
        })
            .addCase(fetchGuest.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchGuest.rejected, (state, action) => {
            return Object.assign(Object.assign(Object.assign({}, state), { loading: 'idle', brands: null }), action.payload);
        })
            .addCase(fetchGuestThanx.fulfilled, (state, action) => {
            return Object.assign(Object.assign(Object.assign({}, state), { loading: 'idle', errors: null, showMagicLink: true }), action.payload);
        })
            .addCase(fetchGuestThanx.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchGuestThanx.rejected, (state, action) => {
            return Object.assign(Object.assign(Object.assign({}, state), { loading: 'idle', showMagicLink: false, brands: null }), action.payload);
        });
    }
});
export const { resetGuest, resetGuestErrors, setGuestEmail } = guestSlice.actions;
export const selectGuest = (state) => state.guest;
export const guestReducer = guestSlice.reducer;
